import React from 'react';
import { Grid2 as Grid, Tooltip, Typography } from '@mui/material';
import { FormattedMessage, FormattedNumber, IntlProvider } from 'react-intl';
import {
  People,
  Campaign as CampaignIcon,
  HistoryEdu as HistoryEduIcon,
} from '@mui/icons-material';

import { Icons } from '../../../../Themes';
import CustomIcon from '../../../DesignSystem/CustomIcon/CustomIcon';
import VotesTypes from '../../../../Utils/Types/VoteTypes';
import EmojiIcon from '../../../DesignSystem/CounterButton/EmojiIcon';
import { AllSteps } from '../../../../Utils/Types';

function PostIndicators({ postContributionsStats, stepTab }: any) {
  if (!postContributionsStats) {
    return null;
  }

  const ICONS_TOOLTIPS_MAP: Record<string, any> = {
    attendees_count: {
      icon: <People color="action" fontSize="medium" />,
      tooltip: <FormattedMessage id="POSTS.INDICATORS.ATTENDEES" />,
    },
    comments_count: {
      icon: <EmojiIcon reaction="comment" size={16} />,
      tooltip: <FormattedMessage id="POSTS.INDICATORS.COMMENTS" />,
    },
    communications_count: {
      icon: <HistoryEduIcon color="action" fontSize="medium" />,
      tooltip: <FormattedMessage id="POSTS.INDICATORS.COMMUNICATIONS" />,
    },
    consultations_count: {
      icon: <CampaignIcon color="action" fontSize="medium" />,
      tooltip: <FormattedMessage id="POSTS.INDICATORS.CONSULTATIONS" />,
    },
    participations_count: {
      icon: <CustomIcon src={Icons.misc.bulb} size={20} />,
      tooltip: <FormattedMessage id="POSTS.INDICATORS.IDEAS" />,
    },
    votes_against_count: {
      icon: <EmojiIcon reaction={VotesTypes.NOT_SUPPORT} size={16} />,
      tooltip: (
        <FormattedMessage
          id="POSTS.INDICATORS.VOTES"
          values={{
            online_count: postContributionsStats.votes_against_online_count,
            offline_count: postContributionsStats.votes_against_offline_count,
          }}
        />
      ),
    },
    votes_for_count: {
      icon: <EmojiIcon reaction={VotesTypes.SUPPORT} size={16} />,
      tooltip: (
        <FormattedMessage
          id="POSTS.INDICATORS.VOTES"
          values={{
            online_count: postContributionsStats.votes_for_online_count,
            offline_count: postContributionsStats.votes_for_offline_count,
          }}
        />
      ),
    },
  };

  const renderItem = (counter: any, count: any) => {
    return (
      <Grid key={`post-indicator-icon-${counter}`}>
        <Tooltip arrow title={ICONS_TOOLTIPS_MAP[counter].tooltip}>
          <Grid container spacing={1} style={{ flexWrap: 'nowrap' }} sx={{ alignItems: 'center' }}>
            <Grid sx={{ display: 'flex' }}>{ICONS_TOOLTIPS_MAP[counter].icon}</Grid>
            <Grid>
              <Typography
                variant="body2"
                component="span"
                color="textSecondary"
                sx={{ fontWeight: 'bold' }}
              >
                <IntlProvider locale="en">
                  <FormattedNumber value={count} notation="compact" compactDisplay="short" />
                </IntlProvider>
              </Typography>
            </Grid>
          </Grid>
        </Tooltip>
      </Grid>
    );
  };

  const filteredCounters = Object.entries(postContributionsStats).filter(([counter]) => {
    return !(
      (counter === 'votes_for_count' || counter === 'votes_against_count') &&
      stepTab &&
      [AllSteps.SUBMISSION, AllSteps.ANALYSIS].includes(stepTab.step_type)
    );
  });

  return (
    <Grid container spacing={3} sx={{ justifyContent: 'flex-start' }}>
      {filteredCounters.map(([counter, count]) => {
        if (ICONS_TOOLTIPS_MAP[counter] && count !== null) {
          return renderItem(counter, count);
        }

        return null;
      })}
    </Grid>
  );
}

export default PostIndicators;
